import i18n from '@/plugins/i18n';
import moment from 'moment';
var dt = new Date();

export const forms = [
    {
        type: 'date',
        name: 'beginDate',
        title: i18n.t('dealer.servicesForm.appointmentDate'),
        format:'YYYY-MM-DD HH:mm:ss',
        default: moment(dt).add(1,'week').format('YYYY-MM-DD'),
        rules: { required: true},
        modal: ['appointment_date'],
        data: ['appointment_date'],
        additionalButton: false,
        checkBox: false
    },
    {
        type: 'select',
        name: 'customer',
        title: i18n.t('dealer.servicesForm.customer'),
        rules: {required: true},
        nextField: 'customeraddresses',
        options: {
            data: [],
            label: 'name',
            search: true,
            track: 'ID'
        },
        modal: ['customer_id'],
        data: ['customer_id',],
        additionalButton: false,
        checkBox: false
    },
    {
        type: 'select',
        name: 'customeraddresses',
        connectField: 'customer',
        title: i18n.t('account.form.address'),
        rules: {required: true},
        modal: ['customer_address'],
        data: ['customer_address'],
        options: {
            data: [],
            label: 'name',
            track: 'ID'
        },
        checkBox: false
    },
    {
        type: 'select',
        name: 'stock',
        title: i18n.t('dealer.servicesForm.product'),
        rules: {required: false},
        modal: ['product_id'],
        data: ['product_id'],
        options: {
            data: [],
            label: 'name',
            track: 'id',
            search: true,
        },
        checkBox: false
    },
    {
        type: 'select',
        name: 'user',
        title: i18n.t('dealer.servicesForm.user'),
        rules: {required: false},
        modal: ['user_id'],
        data: ['user_id'],
        options: {
            data: [],
            labels: ['firstname', 'lastname'],
            track: 'id'
        },
        checkBox: false
    },
    {
        type: 'select',
        name: 'status',
        title: i18n.t('dealer.servicesForm.status'),
        rules: {required: true},
        modal: ['status'],
        data: ['status'],
        default:{ label: i18n.t('dealer.servicesForm.open'), value: 'open' },
        options: {
            type: 'locale',
            data: [
                { label: i18n.t('dealer.servicesForm.open'), value: 'open' },
                { label: i18n.t('dealer.servicesForm.close'), value: 'close' },
            ],
            label: 'label',
            track: 'value'
        },
        checkBox: false
    },
    {
        type: 'select',
        name: 'types',
        title: i18n.t('dealer.servicesForm.type'),
        rules: {required: true},
        modal: ['type'],
        data: ['type'],
        default: { label: i18n.t('dealer.servicesForm.fault'), value: 'fault' },
        options: {
            type: 'locale',
            data: [
                { label: i18n.t('dealer.servicesForm.fault'), value: 'fault' },
                { label: i18n.t('dealer.servicesForm.setup'), value: 'setup' },
            ],
            label: 'label',
            track: 'value'
        },
        checkBox: false
    },
    {
        type: 'editor',
        name: 'desc',
        title: '',
        rules: {},
        modal: ['content'],
        data: ['content'],
        additionalButton: false,
        checkBox: false
    },
]
export default forms;


// WEBPACK FOOTER //
// ./src/pages/General/Dealer/forms/serviceForm.js